import { ApButtonMain, ApIcon, colors } from '@alixpartners/ui-components';
import { ApSignalrConsumer, Telemetry } from '@alixpartners/ui-utils';
import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import {
	ButtonWrapper,
	DescriptionText,
	DropWrapper,
	DropZoneArea,
	DropZoneText,
	IconWrapper,
} from './styles';
import { CATEGORY_UPLOAD_STATUS } from '../../constants';
import ErrorList from '../ErrorList';
import { cleanCategoryState, validateCategoryFile } from 'utils/apiRequests';
import UploadProgressBar from '../UploadProgressBar';
import { getStatusMessage } from './utils';

const errorPoints = [
	CATEGORY_UPLOAD_STATUS.ERRORSTATE,
	CATEGORY_UPLOAD_STATUS.CATEGORYDATAUPLOADFAILED,
	CATEGORY_UPLOAD_STATUS.CATEGORYDATAVALIDATIONFAILED,
];

class index extends React.Component {
	static propTypes = {
		status: PropTypes.object.isRequired,
		refetchCategoryState: PropTypes.func.isRequired,
		fetchFileArchive: PropTypes.func.isRequired,
	};

	dropzoneRef = React.createRef();

	state = {
		statusMessage: '',
		status: this.props.status,
		errors: this.props.status.errors || [],
		currentNormalizationStep: this.props.status.state,
		refetchCategoryState: this.props.refetchCategoryState,
		totalNormalizationSteps: 10,
		isProcessing:
			this.props.status.state !== CATEGORY_UPLOAD_STATUS.NO_DATA &&
			(!this.props.status.errors || this.props.status.errors.length === 0),
		isAnyErrorOccured: errorPoints.includes(this.props.status.state),
	};

	componentDidMount() {
		const { status } = this.props;

		if (status.state === 1) {
			const currentProgressMessage = getStatusMessage(Number(status.state));
			this.setState({
				statusMessage: currentProgressMessage,
				currentNormalizationStep: status.state,
				isProcessing:
					this.props.status.state !== CATEGORY_UPLOAD_STATUS.NO_DATA,
			});
		} else if (typeof status.state === 'number') {
			const currentProgressMessage = getStatusMessage(Number(status.state));
			this.setState({
				isProcessing: true,
				currentNormalizationStep: status.state,
				statusMessage: currentProgressMessage,
			});
		}
		if (
			Number(status.state) === 10 ||
			Number(status.state) === CATEGORY_UPLOAD_STATUS.ERRORSTATE ||
			Number(status.state) ===
				CATEGORY_UPLOAD_STATUS.CATEGORYDATAUPLOADFAILED ||
			Number(status.state) ===
				CATEGORY_UPLOAD_STATUS.CATEGORYDATAVALIDATIONFAILED
		) {
			this.fetchFileAndCleanup();
		}
	}

	// componentDidUpdate(prevProps, prevState) {
	// 	const { status } = this.props;
	// 	const { currentNormalizationStep } = this.state;
	// 	if (!isEqual(prevProps.status, status)) {
	// 		if (status.state !== CATEGORY_UPLOAD_STATUS.NO_DATA) {
	// 			const currentProgressMessage =(status.state);
	// 			this.setState({
	// 				isProcessing: true,
	// 				currentNormalizationStep: status.state,
	// 				statusMessage: currentProgressMessage,
	// 			});
	// 		}
	// 	}
	// 	if (prevState.currentNormalizationStep !== currentNormalizationStep) {
	// 		if (errorPoints.includes(currentNormalizationStep)) {
	// 			this.setState({ isAnyErrorOccured: true });
	// 		}
	// 	}
	// }

	fetchFileAndCleanup() {
		const { fetchFileArchive, refetchCategoryState } = this.props;
		this.setState(
			{
				statusMessage: 'File published successfully.',
				currentNormalizationStep: 10,
				totalNormalizationSteps: 10,
			},
			() => {
				fetchFileArchive();
				cleanCategoryState().then(() => {
					refetchCategoryState();
				});
			}
		);
	}

	onFileSelected = async acceptedFiles => {
		const file = acceptedFiles[0];

		this.setState(
			{
				statusMessage: 'Starting Pipeline',
				isProcessing: true,
			},
			() => {
				validateCategoryFile(file)
					.then(response => {
						const isValid = !response.errors || response.errors.length === 0;
						if (!isValid) {
							this.setState({
								currentNormalizationStep:
									CATEGORY_UPLOAD_STATUS.VALIDATIONFAILED,
							});
						}
					})
					.catch(() => {
						this.setState({
							currentNormalizationStep: CATEGORY_UPLOAD_STATUS.VALIDATIONFAILED,
						});
					});
			}
		);
		Telemetry.trackEvent('file selected');
	};

	restartUploading() {
		const { refetchCategoryState } = this.props;
		cleanCategoryState().then(() => {
			refetchCategoryState();
		});
	}

	renderInitialBlock = () => {
		Telemetry.trackEvent('showing upload file');

		return (
			<React.Fragment>
				<IconWrapper>
					<ApIcon
						iconName="cloud_upload"
						iconSize="96px"
						iconColor={colors.grey3}
					/>
				</IconWrapper>
				<DropZoneText>
					<DescriptionText>
						Drag <span>.csv</span> file here or browse files to upload
					</DescriptionText>
					<ButtonWrapper>
						<ApButtonMain iconName="baseline_add">Add file</ApButtonMain>
					</ButtonWrapper>
				</DropZoneText>
			</React.Fragment>
		);
	};

	renderProcessingBlock = () => {
		const {
			errors,
			statusMessage,
			currentNormalizationStep,
			totalNormalizationSteps,
			refetchCategoryState,
		} = this.state;

		return (
			<>
				<UploadProgressBar
					label={statusMessage}
					value={Math.floor(
						(100 * currentNormalizationStep) / totalNormalizationSteps
					)}
				/>
				{/* 
				<RefreshStatusBlock>
					<ApButtonText
						onClick={() => {
							this.restartUploading();
						}}
					>
						Restart Uploading
					</ApButtonText>
				</RefreshStatusBlock> */}

				<ApSignalrConsumer
					message="CategoryDataPipelineInProgress"
					onMessage={(
						messageKey,
						statusMessage,
						currentNormalizationStep,
						totalNormalizationSteps
					) => {
						if (
							Number(currentNormalizationStep) === 10 ||
							errorPoints.includes(Number(currentNormalizationStep))
						) {
							this.fetchFileAndCleanup();
							refetchCategoryState();
						} else {
							this.setState(
								{
									statusMessage: statusMessage,
									currentNormalizationStep: Number(currentNormalizationStep),
									totalNormalizationSteps: Number(totalNormalizationSteps),
									isProcessing: errors.length === 0,
								},
								() => {
									refetchCategoryState();
								}
							);
						}
					}}
				/>
				<ApSignalrConsumer
					message="CategoryDataPipelineFailed"
					onMessage={() => {
						this.fetchFileAndCleanup();
						refetchCategoryState();
					}}
				/>
				<ApSignalrConsumer
					message="CategoryDataValidationFailed"
					onMessage={() => {
						this.fetchFileAndCleanup();
						refetchCategoryState();
					}}
				/>
				<ApSignalrConsumer
					message="CategoryDataUploadFailed"
					onMessage={() => {
						this.fetchFileAndCleanup();
						refetchCategoryState();
					}}
				/>
			</>
		);
	};

	render() {
		const { isProcessing, errors, currentNormalizationStep } = this.state;
		const { fileName, fileSize, rowsWithErrors } = this.props.status;

		if (isProcessing) {
			return this.renderProcessingBlock();
		}

		return (
			<React.Fragment>
				{currentNormalizationStep === CATEGORY_UPLOAD_STATUS.NO_DATA && (
					<Dropzone
						ref={this.dropzoneRef}
						onDrop={this.onFileSelected}
						style={{}}
						noKeyboard
					>
						{({ getRootProps, getInputProps }) => (
							<DropWrapper {...getRootProps()}>
								<input {...getInputProps()} />
								<DropZoneArea>
									<React.Fragment>{this.renderInitialBlock()}</React.Fragment>
								</DropZoneArea>
							</DropWrapper>
						)}
					</Dropzone>
				)}
				{errors.length > 0 && (
					<ErrorList
						rowsWithErrors={rowsWithErrors}
						errors={errors}
						fileSize={fileSize}
						fileName={fileName}
					/>
				)}
			</React.Fragment>
		);
	}
}

export default index;
